import {useState, useCallback} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {updateResource, readEndpoint} from 'redux-json-api'

import {
  Cancel,
  Continue,
  ControlButton
} from '../../../../../shared_components/ButtonTypes'

import ContactAccountManagerNote from './ContactAccountManagerNote'
import LogoUpload from '../../../../../shared_components/LogoUpload'
import Modal from '../../../../../shared_components/Modal'
import ShadowHeader from '../ShadowHeader'
import ShadowWrapper from '../ShadowWrapper'

import {
  useNotificationContext
} from '../../../../../shared_components/notifications/NotificationContext'

import './editFirmLogo.scss'

export const EditFirmLogo = ({
  firmId,
  isAccountManager,
  isFirmActive,
  logo = '',
  readEndpoint: readEndpointProp,
  updateResource: updateResourceProp
}) => {
  const {alwaysNotify} = useNotificationContext()

  const [logoUrl, setLogoUrl] = useState(logo)
  const [processing, setProcessing] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const resetState = useCallback(() => {
    setLogoUrl(logo || '')
    setShowModal(false)
  }, [logo])

  const toggleModal = useCallback(() => setShowModal(prev => !prev), [])

  const hasLogoChanged = logoUrl !== logo

  const handleSave = useCallback(() => {
    setProcessing(true)

    const attributes = {logo: logoUrl}

    updateResourceProp({
      type: 'firms',
      id: firmId,
      attributes
    }).then(() => {
      setProcessing(false)
      setShowModal(false)
      alwaysNotify.shortSuccess('Firm logo updated.')
      readEndpointProp(`firms/${firmId}`)
    }).catch(() => {
      setProcessing(false)
      alwaysNotify.shortError('Failed to update firm logo.')
    })
  }, [alwaysNotify, firmId, logo, logoUrl, readEndpointProp, updateResourceProp])

  return (
    <ShadowWrapper>
      <div className='edit-firm-logo'>
        {
          logoUrl &&
          <div className='flex-container logo-wrapper'>
            <span>Logo:</span>
            <img alt='firm logo' className='preview-logo' src={logoUrl} />
          </div>
        }
        {isFirmActive && isAccountManager && (
          <div className='edit-config'>
            <ControlButton
              faClass='fa-pencil-square-o'
              onClick={toggleModal}
              buttonText='Edit'
            />
            <Modal visible={showModal}>
              <ShadowHeader headerText='Firm Logo' />
              <div className='logo-upload-wrapper flex-container'>
                <LogoUpload
                  altText='firm-logo'
                  logoUrl={logoUrl}
                  setLogoUrl={setLogoUrl}
                />
              </div>
              <div className='button-group'>
                <Cancel onClick={resetState} />
                <Continue
                  disabled={!hasLogoChanged || processing}
                  loading={processing}
                  onClick={handleSave}>
                  Save
                </Continue>
              </div>
            </Modal>
          </div>
        )}
        <ContactAccountManagerNote isAccountManager={isAccountManager} />
      </div>
    </ShadowWrapper>
  )
}

EditFirmLogo.propTypes = {
  firmId: PropTypes.string.isRequired,
  isAccountManager: PropTypes.bool,
  isFirmActive: PropTypes.bool,
  logo: PropTypes.string,
  readEndpoint: PropTypes.func.isRequired,
  updateResource: PropTypes.func.isRequired
}

export default connect(null, {updateResource, readEndpoint})(EditFirmLogo)
